import localForage from 'localforage';

// SEE: https://localforage.github.io/localForage/

const localStore = localForage.createInstance({
    name: 'ehi',
    storeName: 'localStore',
    driver: [ localForage.LOCALSTORAGE]
});

export default localStore;